<template>
  <div id="leftNav">
    <ul class="leftNav">
      <li class="leftNav-item active"><router-link to="/" class="active"> 首页</router-link></li>
      <li class="leftNav-item"><router-link to="/enterpriseQuery" class="nav-item"><p>立项</p><p>查询</p> </router-link></li>
      <li class="leftNav-item"><router-link to="/assessmentList" class="nav-item"><p>项目</p><p>评估</p> </router-link></li>
      <li class="leftNav-item"><router-link to="/serviceList" class="nav-item"><p>创新</p><p>服务</p></router-link></li>
      <li class="leftNav-item"><router-link to="/notice" class="nav-item"><p>政策</p><p>资讯</p></router-link></li>
      <li class="leftNav-item"><router-link to="/download/14" class="nav-item"><p>下载</p><p>中心</p></router-link></li>
      <li class="leftNav-item"><router-link to="/enterpriseList/9" class="nav-item"><p>服务</p><p>机构</p></router-link></li>
      <li class="leftNav-item"><router-link to="/aboutUs/1" class="nav-item"><p>关于</p><p>我们</p></router-link></li>
    </ul>
  </div>
</template>

<script>
export default {
  name: "leftNav",
  data() {
    return {

    };
  },
  props:['leftTab'],
  methods: {

    }
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.leftNav{
  width: 60px;
  line-height: 16px;
  background: #ffffff;
  color: #777777;
  position: fixed;
  left: 1%;
  top: 20%;
  text-align: center;
  -moz-box-shadow:0px 0px 6px #999; -webkit-box-shadow:0px 0px 6px #999; box-shadow:0px 0px 6px #999;
  z-index: 9;
}

.leftNav-item{
 border-bottom: 1px solid #eee;
 height: 50px;
 padding: 5px;
 box-sizing: border-box;
 font-size: 14px;
 cursor: pointer;
 line-height: 25px;
}
.leftNav-item .nav-item:hover{
  /*color: #ff5555;*/
  color: #ffd21a;
  font-size: 16px;
  font-weight: bold;
}
.leftNav:hover{
  /*width: 62px;*/
  -moz-box-shadow:0px 0px 16px #747474; -webkit-box-shadow:0px 0px 16px #747474; box-shadow:0px 0px 16px #747474;
}

.leftNav :first-child{
  line-height:36px;

}
.active{
  background: #ffd21a;
  /*background: #ff5555;*/
  font-weight: bold;
  color: #fff;
}
.nav-item{
  line-height: 18px !important;
  color: #999;
}
.nav-item p{
  line-height: 16px !important;
}
</style>



// WEBPACK FOOTER //
// src/components/comment/leftNav.vue